@if (userGroup) {
    <div class="ws-flex-container-vertical ws-flex-auto ws-stretch">
        <div class="ws-flex-container-horizontal ws-flex-none">
            <div class="ws-flex-auto ws-truncate">
                <ws-bread-crumbs [breadcrumbs]="breadcrumbs" [currentPageTitle]="userGroup.name"></ws-bread-crumbs>
            </div>
        </div>
        <div class="ws-section ws-flex-none">
            <div class="ws-section__header">
                <h4 class="ws-section__header__title">User Group</h4>
                <div class="ws-section__header__actions">
                    <div class="ws-section__header__actions__item">
                        <div class="action-button-wrapper"
                             helpTooltip
                             helpContentId="app.refresh"
                             position="bottom">
                            <button type="button"
                                    class="ace-btn btn-sm btn-secondary has-icon"
                                    (click)="refresh()"
                                    [disabled]="isPanelEdit">
                                <i class="fa fa-refresh"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        @if (userGroup) {
            <div class="user-group-panels" [class.user-group-panel-expanded]="expandedPanel">
                <user-group-info
                    [class.remove-panel]="expandedPanel && expandedPanel !== 'userGroupInfo'"
                    [userGroup]="userGroup"
                    [canEdit]="canEdit"
                    (expandClicked)="expandClicked($event)">
                </user-group-info>
                @if (!isLicensedUser) {
                    <application-permission-panel
                        [class.remove-panel]="expandedPanel && expandedPanel !== 'applicationPermission'"
                        [userGroup]="userGroup"
                        [canEdit]="canEdit"
                        (expandClicked)="expandClicked($event)">
                    </application-permission-panel>
                    <company-permission-panel
                        [class.remove-panel]="expandedPanel && expandedPanel !== 'companyPermission'"
                        [userGroup]="userGroup"
                        [canEdit]="canEdit"
                        (expandClicked)="expandClicked($event)">
                    </company-permission-panel>
                    <instance-permission-panel
                        [class.remove-panel]="expandedPanel && expandedPanel !== 'instancePermission'"
                        [userGroup]="userGroup"
                        [canEdit]="canEdit"
                        (expandClicked)="expandClicked($event)">
                    </instance-permission-panel>
                }
                @if (isLicensedUser) {
                    <instance-permission-panel
                        [class.remove-panel]="expandedPanel && expandedPanel !== 'instancePermission'"
                        [userGroup]="userGroup"
                        [canEdit]="canEdit"
                        (expandClicked)="expandClicked($event)">
                    </instance-permission-panel>
                    <div></div>
                    <company-permission-panel
                        [class.remove-panel]="expandedPanel && expandedPanel !== 'companyPermission'"
                        [userGroup]="userGroup"
                        [canEdit]="canEdit"
                        (expandClicked)="expandClicked($event)">
                    </company-permission-panel>
                }
            </div>
        }
    </div>
}

